import * as PIXI from 'pixi.js';

export const brightnessBtnFilter = new PIXI.ColorMatrixFilter();
brightnessBtnFilter.brightness(1.3);

export const darkBtnFilter = new PIXI.ColorMatrixFilter();
darkBtnFilter.brightness(0.8);
